<template>
  <div class="box">
  <div class="box1">
      <div class="box2">设备类型：</div>
      <div class="box3">{{equipment.typeName}}</div>
  </div>
    <div class="box1">
      <div class="box2">设备厂家：</div>
      <div class="box3">{{equipment.manufactureName}}</div>
  </div>
    <div class="box1">
      <div class="box2">设备型号：</div>
      <div class="box3">{{equipment.modelName}}</div>
  </div>
    <div class="box1">
      <div class="box2">离线时间：</div>
      <div class="box3">{{equipment.offDate}}</div>
  </div>
    <div class="box1">
      <div class="box2">离线备注：</div>
      <div class="box3">{{equipment.offRemark}}</div>
  </div>
</div>
</template>

<script>
import {devicesOffline} from "@/api/public"
export default {
  data() {
    return {
       equipment:''
    }
  },
  mounted() {
    this.requestdevicesOffline()
  },
  methods:{
    requestdevicesOffline() {
      let equipmentStatusId = this.$utils.getUrlKey('equipmentStatusId')
      devicesOffline({equipmentStatusId:equipmentStatusId}).then(res=>{
        console.log(res)
        this.equipment = res.data
      })
    }
  }
};
</script>

<style scoped lang="scss">
    .box {
    width: 100%;
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    overflow: hidden;
        .box1 {
            width: 100%;
            display: flex;
            font-size: 16px;
            .box2 {
                height: 40px;
                line-height: 40px;
                width: 25%;
                text-align: left
            }
            .box3 {
                flex: 1;
                text-align: left;
                margin-top: 8px;
                line-height: 1.4
            }
        }
}
</style>
